import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsQuickbooksComponent } from './simple-icons-quickbooks.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsQuickbooksComponent ],
    exports:      [ SimpleIconsQuickbooksComponent ],
    bootstrap:    []
})
export class SimpleIconsQuickbooksModule {}
